import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from "@material-ui/core";
import AvTimerIcon from '@material-ui/icons/AvTimer';
import styles from "./styles";
import t from "../../../../languages/pl";

const useStyles = makeStyles(theme => styles(theme, ({ })));

const Layover = ({duration}) => {
    const classes = useStyles();
    return (
        <div className={classes.location}>
            <AvTimerIcon />
            <Typography variant='body2'>
                {t.layoverTime}:&nbsp;{duration}
            </Typography>
        </div>
    );
};

Layover.propTypes = {
    duration: PropTypes.string
};

export default Layover;
